module.exports = __webpack_public_path__ + "static/media/wordpress.14166b98.svg";